import React, { useEffect, useState } from "react";
import { apiRequest } from "../utils/api";
import { useAuthContext } from "../context/AuthContext";
import "../styles/MailSidebar.css";

// 表示するフォルダ一覧（key = currentFolder に一致）
const folderList = [
  { key: "inbox", label: "📥 受信トレイ" },
  { key: "buy_request", label: "📩 買取依頼" },
  { key: "buy_approval", label: "✅ 買取承認" },
  { key: "price_info", label: "💴 最新価格" },
  { key: "id_update", label: "🪪 身分証明書更新" },
  { key: "draft", label: "📝 下書き" },
  { key: "sent", label: "📤 送信済み" },
  { key: "trash", label: "🗑️ ゴミ箱" },
];

const MailSidebar = ({ currentFolder, reloadTrigger, onFolderChange, onReloadClick }) => {
  const { user, loading } = useAuthContext();
  const isAuthenticated = !!user?.id;

  const [folderCounts, setFolderCounts] = useState({});

  useEffect(() => {
    if (loading) return;

    if (!isAuthenticated) {
      setFolderCounts({});
      return;
    }

    const fetchStats = async () => {
      try {
        const res = await apiRequest("inventory/mail/folder_stats/");
        setFolderCounts(res);
      } catch (error) {
        if (error?.skipRequest) return;

        if (error?.status === 401) {
          setFolderCounts({});
          return;
        }

        console.error("folder_stats取得失敗:", error);
      }
    };

    fetchStats();
  }, [loading, isAuthenticated, reloadTrigger]);

  return (
    <div className="mail-sidebar">
      <h3>
        pasomaruhobby
        <label
          className="mail-reload-button"
          onClick={onReloadClick}
        >
          🔄
        </label>
      </h3>

      <ul>
        {folderList.map(({ key, label }) => {
          const unread = folderCounts[key]?.unread || 0;

          return (
            <li
              key={key}
              onClick={() => onFolderChange(key)}
              className={currentFolder === key ? "active" : ""}
            >
              {label}
              {unread > 0 && key !== "sent" && (
                <span className="mail-badge">（{unread}）</span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default MailSidebar;